<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div role="tablist">
          <div class="card">
            <div class="card-header bg-light">
              <div class="row">
                <div class="col-12 col-md-4" v-b-toggle="'collapse'+index" style="cursor: pointer"
                     v-tooltip="'Маълумотларни очиш'">
                  <span><i class="fa fa-arrow-down"></i><b>№{{ index + 1 }}.(#id:{{ itemId }})</b></span>
                </div>
                <div class="col-12 col-md-3">
                  <span><b>{{ fitment.name }}</b></span>
                </div>

                <div class="col-12 col-md-2">
                  <div class="pull-right d-flex align-items-center">
                    <button class="all-btn add-btn" @click="save()" :disabled="processing"
                            v-if="canSave">
                      {{ $t("action.save") }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <hr/>
                </div>
              </div>

            </div>

            <b-collapse :id="'collapse'+index" accordion="my-accordion" role="tabpanel"
                        v-model="isAddValueCollapse">
              <div class="card-body">

                <div class="row">
                  <div class="col-12 col-md-6">

                    <div class="form-group">
                      <label>{{ $t('config.products.productCategory.title') }}<span class="red">*</span></label>
                      <v-select v-model="fitment.productCategoryPlusDto" label="name"
                                :options="productCategories"
                                :filterable="false"
                                @search="onCategorySearch"
                                @search:focus="onCategoryFocus">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.name"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="fitment && fitment.productCategoryPlusDto && fitment.productCategoryPlusDto && fitment.productCategoryPlusDto.name">
                          <div v-html="fitment.productCategoryPlusDto.name"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("empty") }}</span>
                      </v-select>
                    </div>

                    <div class="form-group">
                      <label>{{ $t('config.products.productManufacture.title') }}<span class="red">*</span></label>
                      <v-select v-model="fitment.productManufactureDto" label="name"
                                :options="manufactures"
                                :filterable="false"
                                @search="onProductManufactureSearch"
                                @search:focus="onProductManufactureFocus">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.name"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="fitment && fitment.productManufactureDto && fitment.productManufactureDto.name">
                          <div v-html="fitment.productManufactureDto.name"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("empty") }}</span>
                      </v-select>
                    </div>

                    <div class="form-group">
                      <label>{{
                          fitment.fitmentType === 'JEWELRY' ? 'Заргарлик буйум ишлаб чиққарилган мамлакат' : $t("fitment.madeCountry")
                        }} <span class="red">*</span></label>
                      <v-select v-model="fitment.countryDto" label="name"
                                :options="countryList"
                                :filterable="false"
                                @search="onCountrySearch"
                                @search:focus="onCountryFocus"
                                :class="{invalid : $v.fitment.countryDto.$error}">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.name"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="fitment && fitment.countryDto && fitment.countryDto.name">
                          <div v-html="fitment.countryDto.name"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                      </v-select>
                      <div class="red" v-if="$v.fitment.countryDto.$error">
                        {{ $t("auto.autoType.country") }} {{ $t("messages.combo.empty") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label>Олдин ишлатилган ID</label>
                      <input type="text" class="form-control" v-model="fitment.fitmentParentId"/>
                    </div>

                    <div class="form-group" v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                      <label>{{ $t("fitment.overlayCoefficient") }} <span class="red">*</span></label>
                      <numeric-input class="form-control" v-model="fitment.overlayCoefficient"
                                     :class="{invalid : $v.fitment.overlayCoefficient.$error}"
                                     :controls="false" :precision="3"></numeric-input>
                      <div class="red" v-if="$v.fitment.overlayCoefficient.$error">
                        {{ $t("fitment.overlayCoefficient") }}
                      </div>
                    </div>

                  </div>

                  <div class="col-12 col-md-6">

                    <div class="form-group">
                      <label>{{ $t('config.products.productSubCategory.title') }}<span class="red">*</span></label>
                      <v-select v-model="fitment.productSubCategoryPlusDto" label="name"
                                :options="productSubCategories"
                                :filterable="false"
                                @search="onSubCategorySearch"
                                @search:focus="onSubCategoryFocus"
                                @input="onChangeMethodSub"
                                :class="{invalid : $v.fitment.productSubCategoryPlusDto.$error}">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.name"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="fitment && fitment.productSubCategoryPlusDto && fitment.productSubCategoryPlusDto.name">
                          <div v-html="fitment.productSubCategoryPlusDto.name"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("empty") }}</span>
                      </v-select>
                    </div>

                    <div class="form-group">
                      <label>{{ $t('config.products.productModel.title') }}<span class="red">*</span></label>
                      <v-select v-model="fitment.productModelDto" label="name"
                                :options="productModels"
                                :filterable="false"
                                @search="onProductModelSearch"
                                @search:focus="onProductModelFocus"
                                @input="onChangeMethodModal"
                                :class="{invalid : $v.fitment.productModelDto.$error}">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.name"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="fitment && fitment.productModelDto && fitment.productModelDto.name">
                          <div v-html="fitment.productModelDto.name"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("empty") }}</span>
                      </v-select>
                    </div>

                    <div class="form-group" v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                      <label>{{ $t("fitment.stoneName") }} </label>
                      <input type="text" class="form-control" v-model="fitment.stoneName"/>
                    </div>

                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-6 col-6">
                          <label>{{ $t("fitment.qty") }} <span class="red">*</span></label>
                          <numeric-input class="form-control" v-model="fitment.qty"
                                         :class="{invalid : $v.fitment.qty.$error}"
                                         :controls="false" :precision="3"></numeric-input>
                          <div class="red" v-if="$v.fitment.qty.$error">
                            {{ $t("fitment.qty") }}
                          </div>
                        </div>
                        <div class="col-md-6 col-6" v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY'">
                          <label>
                            <b :class="$v.fitment.unitMeasurementType.$error ? 'red' : ''">{{
                                $t("fitment.um")
                              }}</b>
                            <span class="red">*</span>
                          </label>
                          <select class="form-control" v-model="fitment.unitMeasurementType"
                                  :class="{invalid : $v.fitment.unitMeasurementType.$error}">
                            <option value=""></option>
                            <option :value="option.key" v-for="option in unitMeasurements" :key="option.key">
                              {{ option.name }}
                            </option>
                          </select>
                        </div>
                        <div class="col-md-5 col-6" v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                          <label>
                            <b :class="$v.fitment.weigh.$error ? 'red' : ''">{{ $t("fitment.weigh") }}</b>
                            <span class="red">*</span>
                          </label>
                          <numeric-input class="form-control" v-model="fitment.weigh"
                                         :class="{invalid : $v.fitment.weigh.$error}"
                                         :controls="false" :precision="3"></numeric-input>
                          <div class="red" v-if="$v.fitment.weigh.$error">
                            {{ $t("fitment.weigh") }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group" v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                      <div class="row">
                        <div class="col-md-7 col-6">
                          <label :class="$v.fitment.metalType.$error ? 'red' : ''">
                            {{ $t("fitment.metalType") }}
                            <span class="red">*</span>
                          </label>
                          <select class="form-control"
                                  v-model="fitment.metalType"
                                  @change="calculated"
                                  :class="{invalid : $v.fitment.metalType.$error}">
                            <option value="GOLD">{{ $t("fitment.gold") }}</option>
                            <option value="SILVER">{{ $t("fitment.silver") }}</option>
                          </select>
                        </div>
                        <div class="col-md-5 col-6" v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                          <label>{{ $t("fitment.hallmark") }} <span class="red">*</span></label>
                          <numeric-input class="form-control" v-model="fitment.hallmark"
                                         :class="{invalid : $v.fitment.hallmark.$error}"
                                         :controls="false" :precision="3"></numeric-input>
                          <div class="red" v-if="$v.fitment.hallmark.$error">
                            {{ $t("fitment.hallmark") }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group" v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                      <label>{{ $t("fitment.stonePrice") }} <span class="red">*</span></label>
                      <numeric-input class="form-control" v-model="fitment.stonePrice"
                                     :class="{invalid : $v.fitment.stonePrice.$error}"
                                     :controls="false" :precision="0"></numeric-input>
                      <div class="red" v-if="$v.fitment.stonePrice.$error">
                        {{ $t("fitment.stonePrice") }}
                      </div>
                    </div>

                  </div>

                </div>


              </div>
            </b-collapse>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable no-unused-vars */

import Datepicker from 'vuejs-datepicker';
import AssetDropZone from "@/views/asset/AssetDropZone.vue";
import {numericTypes} from '@/shared/constants/mask';
import initFilterModel from '@/shared/filter';
import {UNIT_MEASUREMENT, MADE_COUNTRY, PROVINCE, PART_CONDITION, FITMENT_TYPE} from '@/shared/constants/fitment';
import {required, requiredUnless} from "vuelidate/lib/validators";
import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
import {VBToggle} from 'bootstrap-vue/es/directives/toggle/toggle'
import InnerImageZoom from 'vue-inner-image-zoom';
import {BFormRadioGroup} from 'bootstrap-vue/es/components/form-radio/form-radio-group'
import {BFormGroup} from 'bootstrap-vue/es/components/form-group/form-group'

export default {
  props: {
    itemId: {
      default: null
    },
    index: {
      default: 0
    },
    isRemoveFile: {
      type: Boolean,
      default: false
    },
    isEditableFile: {
      type: Boolean,
      default: false
    },
    objectType: {
      type: String,
      default: null
    },
    parentId: {
      default: null
    },
    appraisalStatusEnum: {
      default: null
    }
  },
  components: {
    AssetDropZone,
    BCollapse,
    Datepicker,
    BFormGroup,
    BFormRadioGroup,
    InnerImageZoom
  },
  directives: {
    'b-toggle': VBToggle
  },
  data() {
    return {
      processing: false,
      numericTypes: numericTypes,
      show: false,
      isAddValueCollapse: false,
      fitment: {
        id: null,
        parentId: this.$props.parentId,
        objectType: this.$props.objectType,
        productCategoryPlusDto: {},
        productSubCategoryPlusDto: {},
        productManufactureDto: {},
        productModelDto: {},
        conditionType: null,
        fitmentType: null,
        fitmentPictures: [],
        fitmentTexPassports: [],
        appraisalStatusEnum: 'Unreviewed',
        parentStatus: 'Pending',
        parentAppraisalStatusEnum: 'Unreviewed',
        unitMeasurementType: "GRAM",
        metalType: null,
        metalTypeName: '',
        qty: 0,
        dilapidationValue: 0,
        totalGovPrice: 0,
        stonePrice: null,
        hallmark: null,
        weigh: null,
        overlayCoefficient: null,
        fitmentParentId: null,
        apiData: false,
        countryDto: null,
        gramPriceInSum: 0
      },
      unitMeasurements: UNIT_MEASUREMENT,
      dilapidation15: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 97.5, 100],
      partConditions: PART_CONDITION,
      fitmentTypes: FITMENT_TYPE,
      productCategoryFilter: initFilterModel(),
      subCategoryFilter: initFilterModel(),
      productManufactureFilter: initFilterModel(),
      productModelFilter: initFilterModel(),
      filter: initFilterModel(),
      selectedFitmentDocsTab: "images",
      prev: '<i class="material-icons">keyboard_arrow_left</i>',
      next: '<i class="material-icons">keyboard_arrow_right</i>',
      productCategories: [],
      productSubCategories: [],
      manufactures: [],
      productModels: [],
      countryList: [],
      coefficient: 0,
      status: null,
      entiteCreateType: null
    }
  },
  validations() {
    return {
      fitment: {
        productCategoryPlusDto: {
          id: {
            required: required
          }
        },
        productSubCategoryPlusDto: {
          id: {
            required: required
          }
        },
        productManufactureDto: {
          id: {
            required: required
          }
        },
        productModelDto: {
          id: {
            required: required
          }
        },
        countryDto: {
          id: {
            required: required
          }
        },
        fitmentType: {
          required: required
        },
        qty: {
          required: requiredUnless(() => {
            return (this.entiteCreateType === 'EXPERT2');
          }),
        },
        unitMeasurementType: {
          required: requiredUnless(() => {
            return (this.fitment.fitmentType === 'JEWELRY');
          })
        },
        hallmark: {
          required: requiredUnless(() => {
            return (this.fitment.fitmentType !== 'JEWELRY');
          })
        },
        weigh: {
          required: requiredUnless(() => {
            return (this.fitment.fitmentType !== 'JEWELRY');
          })
        },
        metalType: {
          required: requiredUnless(() => {
            return (this.fitment.fitmentType !== 'JEWELRY');
          })
        },
        stonePrice: {
          required: requiredUnless(() => {
            return (this.fitment.fitmentType !== 'JEWELRY');
          })
        },
        overlayCoefficient: {
          required: requiredUnless(() => {
            return (this.fitment.fitmentType !== 'JEWELRY');
          })
        }
      }
    };
  },
  computed: {
    // canSave() {
    //   return (this.appraisalStatusEnum === 'Unreviewed' || this.appraisalStatusEnum === 'NotFullyEvaluated');
    // },

    canSave() {
      // return (this.fitment.entiteCreateType === 'API_EXARID' && !this.fitment.appraisalStatusEnum || this.fitment.appraisalStatusEnum === 'Unreviewed'
      //     || this.fitment.appraisalStatusEnum === 'NotFullyEvaluated' || this.fitment.appraisalStatusEnum === 'SentToComplement');
      return true
    },
    canRemoveFile() {
      return this.status && this.status !== 'Rated' && this.status !== 'Confirmed' && this.status !== 'Rejected' && this.hasPermission('NEW_FITMENT_IMAGE_DELETE')
    }
  },
  methods: {
    init() {
      const vm = this;
      const id = this.$props.itemId;
      vm.entiteCreateType = this.$route.query.entiteCreateType;
      let objectType = "Fitment";

      const promises = [
        vm.$http.get('fitment/metalType/' + (id ? id : 0) + '/' + vm.$props.parentId + '/' + objectType)
      ];

      if (id && id > 0) {
        vm.isPageLoadInit = true;
        promises.push(vm.$http.get('fitment/item/' + id));
      }

      Promise.all(promises).then(function (values) {
        const result = values[0].data;
        if (result.status === 'FAIL') {
          vm.$router.push('/fitment/list');
        }

        vm.metalTypes = result.data.metalType;
        if (values.length >= 2) {
          vm.fitment = values[1].data;
          console.log("vm.fitment = ", vm.fitment)
          vm.fitment.objectType = objectType;
          if (vm.fitment.assetItemId) {
            vm.fitment.parentId = vm.fitment.assetItemId;
          } else if (vm.fitment.evlObjectId) {
            vm.fitment.parentId = vm.fitment.evlObjectId;
          }

          if (vm.fitment.parentAppraisalStatusEnum) {
            vm.status = vm.fitment.parentAppraisalStatusEnum;
          } else if (vm.fitment.parentStatus) {
            vm.status = vm.fitment.parentStatus;
          }

          vm.fitment.fitmentPictures.forEach((file) => {
            vm.fitmentAllPhotos.push(file);
          });
          vm.isPageLoadInit = false;
        }

        if (!vm.fitment.productCategoryPlusDto) {
          vm.fitment.productCategoryPlusDto = {
            parent: {}
          };
        }

      });
    },
    cancel() {
      this.$router.push('/fitment/edit/' + this.fitment.parentId);
    },
    save() {

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.processing = true;
      this.fitment.evlObjectId = this.fitment.parentId;
      this.$http.post('fitment/item/plus/save', this.fitment)
          .then(res => {
            if (res.data.status === 'SUCCESS') {
              this.fitment.id = res.data.data;
              this.isAddValueCollapse = true;
              window.location.reload();
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: this.$t(res.data.message),
                type: 'warning'
              });
            }
            this.processing = false;
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('messages.realEstate.error'),
              type: 'error'
            });
            this.processing = false;
          });
    },


    onCategorySearch(searchTxt, loading) {
      loading(true);
      this.productCategoryFilter.search = searchTxt;
      this.searchMethodCategory(loading);
    },
    onCategoryFocus() {
      this.productCategoryFilter.search = '';
      this.searchMethodCategory();
    },
    searchMethodCategory(loading) {
      this.productCategories = [];
      this.productSubCategories = [];
      this.productCategoryFilter.objectId = this.fitment.parentId;
      this.$http.post('product-category-plus/search', this.productCategoryFilter).then(res => {
        if (loading)
          loading(false);
        this.productCategories = res.data.data;
      }, err => {
        console.log(err);
      });
    },

    onSubCategorySearch(searchTxt, loading) {
      if (!this.fitment.productCategoryPlusDto) {
        return;
      }
      loading(true);
      this.subCategoryFilter.search = searchTxt;
      this.subCategoryFilter.parentId = this.fitment.productCategoryPlusDto.id;
      this.searchMethodSubCategory(loading);
    },
    onSubCategoryFocus() {
      if (!this.fitment.productCategoryPlusDto) {
        return;
      }
      this.subCategoryFilter.search = '';
      this.subCategoryFilter.parentId = this.fitment.productCategoryPlusDto.id;
      this.searchMethodSubCategory();
    },
    searchMethodSubCategory(loading) {
      this.productSubCategories = [];
      this.$http.post('product-sub-category-plus/search', this.subCategoryFilter)
          .then(res => {
            if (loading)
              loading(false);
            this.productSubCategories = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    onProductManufactureSearch(searchTxt, loading) {
      loading(true);
      this.productManufactureFilter.search = searchTxt;
      this.productManufactureFilter.productCategoryId = this.fitment.productCategoryPlusDto.id;
      this.productManufactureFilter.productSubCategoryId = this.fitment.productSubCategoryPlusDto.id;
      this.searchProductManufacture(loading);
    },

    onProductManufactureFocus() {
      this.productManufactureFilter.search = '';
      this.productManufactureFilter.productCategoryId = this.fitment.productCategoryPlusDto.id;
      this.productManufactureFilter.productSubCategoryId = this.fitment.productSubCategoryPlusDto.id;
      this.searchProductManufacture();
    },

    searchProductManufacture(loading) {
      this.manufactures = [];
      this.$http.post('product-manufacture/search', this.productManufactureFilter)
          .then(res => {
            if (loading)
              loading(false);
            this.manufactures = res.data.data;
          }, err => {
            console.log(err);
          });
    },


    onProductModelSearch(searchTxt, loading) {
      loading(true);
      this.productModelFilter.search = searchTxt;
      this.productModelFilter.productCategoryId = this.fitment.productCategoryPlusDto.id;
      this.productModelFilter.productSubCategoryId = this.fitment.productSubCategoryPlusDto.id;
      this.productModelFilter.productManufactureId = this.fitment.productManufactureDto.id;
      this.searchProductModel(loading);
    },

    onProductModelFocus() {
      this.productModelFilter.search = '';
      console.log("this.fitment.productManufactureDto = ", this.fitment.productManufactureDto)
      this.productModelFilter.productCategoryId = this.fitment.productCategoryPlusDto.id;
      this.productModelFilter.productSubCategoryId = this.fitment.productSubCategoryPlusDto.id;
      this.productModelFilter.productManufactureId = this.fitment.productManufactureDto.id;
      this.searchProductModel();
    },

    searchProductModel(loading) {
      this.productModels = [];
      this.$http.post('product-model/search', this.productModelFilter)
          .then(res => {
            console.log(" product-model/search ", this.fitment);
            console.log(" product-model/search  res.data.data", res.data.data);

            if (loading)
              loading(false);
            this.productModels = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    onCountrySearch(searchTxt) {
      this.countryList = [];
      this.filter.search = searchTxt;
      this.$http.post('country/search', this.filter)
          .then(res => {
            this.countryList = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onCountryFocus() {
      this.countryList = [];
      this.filter.search = '';
      this.$http.post('country/search', this.filter)
          .then(res => {
            this.countryList = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    onChangeMethodSub() {
      if (this.fitment.productCategoryPlusDto.fitmentType) {
        this.fitment.fitmentType = this.fitment.productCategoryPlusDto.fitmentType;
        this.calculated();
      }
    },
    onChangeMethodModal() {
      if (this.fitment.productModelDto) {
        console.log(" this.fitment.productModelDto ", this.fitment.productModelDto);
        this.fitment.fitmentType = this.fitment.productModelDto.fitmentType.code;
      }
    },
    getCoefficient(usdPrice) {
      if (usdPrice < 10000) {
        this.coefficient = 1;
      } else if (usdPrice < 20000) {
        this.coefficient = 1.5;
      } else if (usdPrice < 40000) {
        this.coefficient = 2.5;
      } else if (usdPrice < 60000) {
        this.coefficient = 4;
      } else if (usdPrice < 100000) {
        this.coefficient = 8;
      } else if (usdPrice < 200000) {
        this.coefficient = 15;
      } else if (usdPrice < 500000) {
        this.coefficient = 30;
      } else if (usdPrice < 1000000) {
        this.coefficient = 58;
      } else {
        this.coefficient = 75;
      }
    }
  },
  created() {
    this.init();
  }
}
</script>

<style scoped>
.live__scroll {
  vertical-align: middle;
  overflow-x: scroll;
  overflow-y: visible;
  height: 15rem;
}

.flex {
  display: flex;
  flex-wrap: nowrap;
}

.cadastre-building-input {
  border: 1px solid #cccccc;
  border-radius: 5px;
  min-height: 40px;
  align-items: center;
  padding: 5px;
  font-size: 15px;
  background-color: #fff;
}

.cadastre-building-input2 {
  border: 1px solid #cccccc;
  border-radius: 5px;
  min-height: 40px;
  align-items: center;
  padding: 5px;
  font-size: 15px;
  background-color: #fff;
  color: grey;
}

.valid {
  border: 1px solid #e53935;;
  border-radius: 5px;
  min-height: 40px;
  align-items: center;
  padding: 5px;
  font-size: 15px;
  background-color: #fff;
  color: grey;
}

.cadastre-building-wrapper {
  cursor: pointer;
}

.cadastre-building-wrapper p:hover {
  border: 1px solid #60B4FA;
  background-color: #D6EBFE;
}
</style>